import Swiper from "swiper"
import { Navigation, Pagination } from "swiper/modules"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"

export function renderGallery(gallery) {
  new Swiper(gallery, {
    modules: [Navigation, Pagination],
    rewind: true,
    lazy: true,
    loadPrevNext: true,
    lazyPreloadPrevNext: 1,
    spaceBetween: 24,
    slidesPerView: "auto",
    centeredSlides: true,
    grabCursor: true,

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  })
}
